export default {
  ticketList: state => state.ticketList,
  headersSettings: state => state.headersSettings,
  sevenTaxes: state => state.sevenTaxes,
};
